import React from 'react'
import { Box, Chip, CircularProgress, Divider, Grid, Typography,Button } from '@material-ui/core'

import SingleCalenderComp from '../../../../../shared/elements/DatePickerCustom/SingleCalenderComp'
import moment from 'moment'
import { FilterToUTC, patientTimeZone, specialityOfPrivider } from '../../../../../containers/AppointmentList/utils'
import calenderTick from '../../../../../assests/images/calenderTick.svg'

import { calculateAge, getNextTwoBusinessDays, nameAvatar, transLate } from '../../../../utils'
// import { Button } from '@mui/material'

import RadioGroup from '@mui/material/RadioGroup'
import FormControlLabel from '@mui/material/FormControlLabel'
import FormControl from '@mui/material/FormControl'
import CheckboxOption from '../../../../ClinicalNotes/reusable/CheckboxOptions'
import ClearIcon from '@mui/icons-material/Clear'
import AddIcon from '@mui/icons-material/Add';
import { useNotification } from '../../../MaterialUi/Notification'
import { providerListForBook, providerListForBookID } from '../../../../../services/Appointments/appointments'
import { useDispatch, useSelector } from 'react-redux'
import { setOfferedDate } from '../../../../../store/actions/appointments'

const ProviderDetails = ({
    providerDetailsForModal,
    isMobileView,
    providerDetails,
    closeModal,
    showDemoGraphy,
    specialty,
    visit_type,
    setProviderVisitType,
    patientState = '',
    selctedValue
}) => {
    const notification = useNotification()
    const dispatch = useDispatch()
    const [openCalender, setOpenCalender] = React.useState(true)
    const stepperRef = React.useRef(null)
    // const nowPST = moment().tz('US/Pacific');
    const [value, setValues] = React.useState({
        morning: false,
        afternoon: false,
        evening: false,
        timezone: '',
        date: getNextTwoBusinessDays(moment(), 3),
    })
    const [step, setStep] = React.useState(1)
    const [openCalenderSmall, setOpenCalenderSmall] = React.useState(false)
    const [selectedTimes, setSelectedTimes] = React.useState([])
    const [availabilityLoading, setAvailabilityLoading] = React.useState(false)
    const [filterTime, setFilterTime] = React.useState({
        startTime: null,
        endTime: null,
    })
    const PatientCreateObject = useSelector((state) => state?.patient?.patientCreateObject)
    const patientAge = calculateAge(PatientCreateObject?.dob)
    const timeZoneOfPatient = useSelector((state) => state?.patient?.patientTimeZone)
    const setSelectedTime = () => {
        // const isToday = value?.date?.isSame(moment().tz('US/Pacific'), 'day')
        // const nowPST = moment().tz('US/Pacific')
        // const hour = nowPST.format('HH')
        // const minute = nowPST.format('mm')
        // if (isToday) {
        //     if (
        //         (value?.morning && value?.afternoon && value?.evening) ||
        //         (value?.morning && value?.evening)
        //     ) {
        //         if (hour < 8) {
        //             return setFilterTime({
        //                 startTime: FilterToUTC(value?.date.format('MM/DD/YYYY'), 8),
        //                 endTime: FilterToUTC(value?.date.format('MM/DD/YYYY'), 18),
        //             })
        //         } else {
        //             return setFilterTime({
        //                 startTime: FilterToUTC(value?.date.format('MM/DD/YYYY'), hour, '', minute),
        //                 endTime: FilterToUTC(value?.date.format('MM/DD/YYYY'), 18),
        //             })
        //         }
        //     } else if (value?.morning && value?.afternoon) {
        //         if (hour < 8) {
        //             return setFilterTime({
        //                 startTime: FilterToUTC(value?.date.format('MM/DD/YYYY'), 8),
        //                 endTime: FilterToUTC(value?.date.format('MM/DD/YYYY'), 17),
        //             })
        //         } else {
        //             return setFilterTime({
        //                 startTime: FilterToUTC(value?.date.format('MM/DD/YYYY'), hour, '', minute),
        //                 endTime: FilterToUTC(value?.date.format('MM/DD/YYYY'), 17),
        //             })
        //         }
        //     } else if (value?.afternoon && value?.evening) {
        //         if (hour < 12) {
        //             return setFilterTime({
        //                 startTime: FilterToUTC(value?.date.format('MM/DD/YYYY'), 12),
        //                 endTime: FilterToUTC(value?.date.format('MM/DD/YYYY'), 18),
        //             })
        //         } else {
        //             return setFilterTime({
        //                 startTime: FilterToUTC(value?.date.format('MM/DD/YYYY'), hour, '', minute),
        //                 endTime: FilterToUTC(value?.date.format('MM/DD/YYYY'), 18),
        //             })
        //         }
        //     } else if (value?.morning) {
        //         if (hour < 8) {
        //             return setFilterTime({
        //                 startTime: FilterToUTC(value?.date.format('MM/DD/YYYY'), 8),
        //                 endTime: FilterToUTC(value?.date.format('MM/DD/YYYY'), 12),
        //             })
        //         } else {
        //             return setFilterTime({
        //                 startTime: FilterToUTC(value?.date.format('MM/DD/YYYY'), hour, '', minute),
        //                 endTime: FilterToUTC(value?.date.format('MM/DD/YYYY'), 12),
        //             })
        //         }
        //     } else if (value?.afternoon) {
        //         if (hour < 12) {
        //             return setFilterTime({
        //                 startTime: FilterToUTC(value?.date.format('MM/DD/YYYY'), 12),
        //                 endTime: FilterToUTC(value?.date.format('MM/DD/YYYY'), 17),
        //             })
        //         } else {
        //             return setFilterTime({
        //                 startTime: FilterToUTC(value?.date.format('MM/DD/YYYY'), hour, '', minute),
        //                 endTime: FilterToUTC(value?.date.format('MM/DD/YYYY'), 17),
        //             })
        //         }
        //     } else if (value?.evening) {
        //         if (hour < 17) {
        //             return setFilterTime({
        //                 startTime: FilterToUTC(value?.date.format('MM/DD/YYYY'), 17),
        //                 endTime: FilterToUTC(value?.date.format('MM/DD/YYYY'), 18),
        //             })
        //         } else {
        //             return setFilterTime({
        //                 startTime: FilterToUTC(value?.date.format('MM/DD/YYYY'), hour, '', minute),
        //                 endTime: FilterToUTC(value?.date.format('MM/DD/YYYY'), 18),
        //             })
        //         }
        //     } else {
        //         return setFilterTime({
        //             startTime: '',
        //             endTime: '',
        //         })
        //     }
        // } else {
        //     if (
        //         (value?.morning && value?.afternoon && value?.evening) ||
        //         (value?.morning && value?.evening)
        //     ) {
        //         return setFilterTime({
        //             startTime: FilterToUTC(value?.date.format('MM/DD/YYYY'), 8),
        //             endTime: FilterToUTC(value?.date.format('MM/DD/YYYY'), 18),
        //         })
        //     } else if (value?.morning && value?.afternoon) {
        //         return setFilterTime({
        //             startTime: FilterToUTC(value?.date.format('MM/DD/YYYY'), 8),
        //             endTime: FilterToUTC(value?.date.format('MM/DD/YYYY'), 17),
        //         })
        //     } else if (value?.afternoon && value?.evening) {
        //         return setFilterTime({
        //             startTime: FilterToUTC(value?.date.format('MM/DD/YYYY'), 12),
        //             endTime: FilterToUTC(value?.date.format('MM/DD/YYYY'), 18),
        //         })
        //     } else if (value?.morning) {
        //         return setFilterTime({
        //             startTime: FilterToUTC(value?.date.format('MM/DD/YYYY'), 8),
        //             endTime: FilterToUTC(value?.date.format('MM/DD/YYYY'), 12),
        //         })
        //     } else if (value?.afternoon) {
        //         return setFilterTime({
        //             startTime: FilterToUTC(value?.date.format('MM/DD/YYYY'), 12),
        //             endTime: FilterToUTC(value?.date.format('MM/DD/YYYY'), 17),
        //         })
        //     } else if (value?.evening) {
        //         return setFilterTime({
        //             startTime: FilterToUTC(value?.date.format('MM/DD/YYYY'), 17),
        //             endTime: FilterToUTC(value?.date.format('MM/DD/YYYY'), 18),
        //         })
        //     } else {
        //         return setFilterTime({
        //             startTime: '',
        //             endTime: '',
        //         })
        //     }
        // }
        if (
            (value?.morning && value?.afternoon && value?.evening) ||
            (value?.morning && value?.evening)
        ) {
            return setFilterTime({
                startTime: FilterToUTC(value?.date.format('MM/DD/YYYY'), 8, timeZoneOfPatient),
                endTime: FilterToUTC(value?.date.format('MM/DD/YYYY'), 18,timeZoneOfPatient) ,
            })
        } else if (value?.morning && value?.afternoon) {
            return setFilterTime({
                startTime: FilterToUTC(value?.date.format('MM/DD/YYYY'), 8 , timeZoneOfPatient),
                endTime: FilterToUTC(value?.date.format('MM/DD/YYYY'), 17 , timeZoneOfPatient),
            })
        } else if (value?.afternoon && value?.evening) {
            return setFilterTime({
                startTime: FilterToUTC(value?.date.format('MM/DD/YYYY'), 12 , timeZoneOfPatient),
                endTime: FilterToUTC(value?.date.format('MM/DD/YYYY'), 18 , timeZoneOfPatient),
            })
        } else if (value?.morning) {
            return setFilterTime({
                startTime: FilterToUTC(value?.date.format('MM/DD/YYYY'), 8 , timeZoneOfPatient),
                endTime: FilterToUTC(value?.date.format('MM/DD/YYYY'), 12 , timeZoneOfPatient),
            })
        } else if (value?.afternoon) {
            return setFilterTime({
                startTime: FilterToUTC(value?.date.format('MM/DD/YYYY'), 12 , timeZoneOfPatient),
                endTime: FilterToUTC(value?.date.format('MM/DD/YYYY'), 17 , timeZoneOfPatient),
            })
        } else if (value?.evening) {
            return setFilterTime({
                startTime: FilterToUTC(value?.date.format('MM/DD/YYYY'), 17 , timeZoneOfPatient),
                endTime: FilterToUTC(value?.date.format('MM/DD/YYYY'), 18 , timeZoneOfPatient),
            })
        } else {
            return setFilterTime({
                startTime: '',
                endTime: '',
            })
        }
    }
    const [newTimeSlot, setNewTimeSlot] = React.useState([])
    const setValue = (value, fieldName) => {
        setValues((state) => {
            return {
                ...state,
                [fieldName]: value,
            }
        })
    }
    const onSelectDate = (value) => {
        setValue(moment(value), 'date')
    }
    const openTheCalender = () => {
        setOpenCalenderSmall(true)
    }
    const closeTheCalender = () => {
        setOpenCalenderSmall(false)
    }
    const handleFilterControl = (field) => {
        if(selectedTimes.includes(field)){
            if(selectedTimes.length > 1){
                setSelectedTimes((arr) => arr.filter((t) => t !== field))
                setValues((prev) => ({ ...prev, [field]: false }))
            }else{
                notification('Atleast one filter should be selected!', 'warning')
            }
        }else{
            setSelectedTimes([...selectedTimes,field])
            setValues((prev) => ({ ...prev, [field]: true }))
        }
        
    }
    const capitalText = (value) => {
        return value.charAt(0).toUpperCase() + value.slice(1)
    }
    const handleChangeOnclick = (slot) => {
        providerDetails(slot, providerDetailsForModal)
    }
    const handleChangeOnremove = () => {
        providerDetails({}, {})
    }
    const searchForPerticulatProvider = async () => {
        try {
            setStep(3)
            setAvailabilityLoading(true)
            const payload = {
                start_date: filterTime?.startTime.format('YYYY-MM-DDTHH:mm:ss[Z]'),
                end_date: filterTime?.endTime.format('YYYY-MM-DDTHH:mm:ss[Z]'),
                is_morning: value?.morning,
                is_afternoon: value?.afternoon,
                is_evening: value?.evening,
                specialty:
                    specialty.toLowerCase().trim() == 'psychiatrya' ||
                    specialty.toLowerCase().trim() == 'psychiatryc'
                        ? 'psychiatry'
                        : specialty.toLowerCase().trim(),
                state: patientState, // this key added for advanceMD
                visit_type: visit_type, // this key added for advanceMD
                prof_id: providerDetailsForModal?.id,
                timezone: timeZoneOfPatient || 'US/Pacific',
                age: patientAge
                    // specialty?.toLowerCase().trim() === 'psychiatrya'
                    // ? 18
                    //     : specialty?.toLowerCase().trim() === 'psychiatryc'
                    //     ? 17
                    // : patientAge
            }
            const res = await providerListForBookID(payload)
            let providerData = res?.data?.data
            //this filter we apply when we use advanceMD and same concept commented in handleOpenTimeBookingMode()
            if (
                value?.morning &&
                !value?.afternoon &&
                value?.evening
            ) {
                const freeTimeStart = FilterToUTC(value?.date.format('MM/DD/YYYY'), 12, timeZoneOfPatient)
                const freeTimeEnd = FilterToUTC(value?.date.format('MM/DD/YYYY'), 17, timeZoneOfPatient)
                const filterTime = res?.data?.data.length && res?.data?.data.map((item)=>{
                    return{
                        ...item,    
                        slots: item.slots.length && item.slots.filter((innerItem)=>(moment(innerItem.start_time).utc() < freeTimeStart &&
                                moment(innerItem.end_time).utc() <= freeTimeStart) ||
                                (moment(innerItem.start_time).utc() >= freeTimeEnd &&
                                    moment(innerItem.end_time).utc() > freeTimeEnd))
                        }
                })
                providerData = filterTime
            }
            //this filter apply because if slot key length is 0 then that provider is not shown in UI for advanceMD
            providerData = providerData.length && providerData.filter((item)=> item.slots.length > 0)
            setNewTimeSlot(providerData[0] || []);
            setAvailabilityLoading(false)
        } catch (err) {
            console.log('err', err)
            setAvailabilityLoading(false)
        }
    }
    const scrollTop = () => {
        stepperRef.current.parentElement.parentElement.scrollTop = 0
    }
    React.useEffect(() => {
        const updatedTimes = Object.keys(value).filter((key) => value[key] === true)
        setSelectedTimes(
            updatedTimes.filter((k) => ['morning', 'afternoon', 'evening'].includes(k)),
        )
        setSelectedTime()
        dispatch(setOfferedDate({
            "first_given_date" : providerDetailsForModal?.dates?.length > 0 ? providerDetailsForModal?.dates[0]?.date : null,
            "second_given_date" : providerDetailsForModal?.dates?.length > 1 ? providerDetailsForModal?.dates[1]?.date : null,
            "third_given_date" : providerDetailsForModal?.dates?.length > 2 ? providerDetailsForModal?.dates[2]?.date : null
        }))
    }, [value])
    React.useEffect(()=>{
        if(filterTime?.startTime && step == 3){
            searchForPerticulatProvider()
        }
    },[filterTime])
    return (
        <div
            style={{
                display: 'flex',
                alignItems: 'flex-start',
                gap: '10px',
                flexDirection: isMobileView ? 'column' : 'unset',
            }}
            ref={stepperRef}>
            <div className="provider_card_content">
                <div
                    className="left_section"
                    style={{
                        flexDirection: 'column',
                        alignItems: 'center',
                        width: !isMobileView ? '350px' : 'unset',
                        padding: '20px',
                    }}>
                    <div>
                        {providerDetailsForModal?.avatar ? (
                            <img
                                style={{
                                    borderRadius: '80px',
                                    border: '2px solid #D8D8D8',
                                }}
                                alt="avatar"
                                src={`data:image/jpeg;base64,${providerDetailsForModal?.avatar}`} //we get the base64 image from advanceMd
                                height={63}
                                width={60}
                            />
                        ) : (
                            nameAvatar(
                                `${providerDetailsForModal?.first_name} ${providerDetailsForModal?.last_name}`,
                            )
                        )}
                    </div>
                    <div className="about_doctor">
                        <Typography className="name" style={{ color: '#3E3E3E' }}>
                            {`${providerDetailsForModal?.first_name} ${providerDetailsForModal?.last_name}`}
                        </Typography>
                    </div>
                    <div className="about_doctor">
                        <Typography className="practice" style={{ color: '#3E3E3E' }}>
                            {specialityOfPrivider(providerDetailsForModal?.specialities)}
                        </Typography>
                    </div>
                    <div className="about_doctor" style={{ color: '#3E3E3E' }}>
                        <div
                            style={{
                                height: !isMobileView ? '230px' : 'unset',
                                overflowY: !isMobileView ? 'auto' : 'unset',
                            }}>
                            <Typography className="description" style={{ color: '#3E3E3E' }}>
                                {providerDetailsForModal?.description}
                            </Typography>
                        </div>
                        <span className="select-another-providerText" onClick={closeModal}>
                            Select another provider
                        </span>
                    </div>
                </div>
            </div>
            {!isMobileView && (
                <Divider
                    variant="middle"
                    orientation="vertical"
                    style={{ height: '450px', backgroundColor: '#D6D6D6', marginTop: '10px' }}
                />
            )}
            <div className="right-container-modal">
                <div style={{ height: !isMobileView ? '400px' : 'unset' }}>
                    {step == 1 && (
                        <>
                            <Typography className="upcoming-text">
                                Upcoming Appointments{' '}
                            </Typography>
                            <Divider style={{ backgroundColor: '#D6D6D6' }} />
                            <div className="right-container">
                                {providerDetailsForModal?.dates?.length > 0 &&
                                    providerDetailsForModal.dates.map((item, index) => (
                                        <div className="date-conatiner">
                                            {/* Show the main date */}
                                            <Typography className="dayText">
                                                {moment(item?.date).format('dddd, MMMM D')}
                                            </Typography>
                                            <div
                                                style={{
                                                    display:'flex',
                                                    flexWrap: 'wrap',
                                                    gap: '5px',
                                                    alignItem: 'center'
                                                }}>
                                                {/* Loop through time slots if present */}
                                                {item?.slots?.length > 0 &&
                                                    item.slots.map((slot, index2) => (
                                                        <div
                                                            className="timeContainer"
                                                            onClick={() => {
                                                                handleChangeOnclick(slot)
                                                                setProviderVisitType(providerDetailsForModal?.visitType)
                                                            }}
                                                            style={{
                                                                background:
                                                                    selctedValue?.start_time ==
                                                                        slot?.start_time &&
                                                                    '#4765B8',
                                                                color:
                                                                    selctedValue?.start_time ==
                                                                        slot?.start_time && '#fff',
                                                            }}>
                                                            {patientTimeZone(
                                                                slot?.start_time,timeZoneOfPatient
                                                            ).format('h:mm A')}
                                                        </div>
                                                    ))}
                                            </div>
                                        </div>
                                    ))}
                                {providerDetailsForModal?.dates?.length === 0 && (
                                    <div style={{display:'flex', alignItems:'center', height: '100%'}}>
                                        <Typography className='noShowTime'>This provider does not have availability for the next 3 business days. Please make a custom date selection or give us a call at (855) 446-8628</Typography>
                                    </div>
                                )}
                            </div>
                        </>
                    )}
                    {step == 2 && (
                        <div className="upcoming-text">
                            <div className="select-a-time-body-header d-md-none">
                                <Typography style={{ marginLeft: 10, marginBottom: 15 }}>
                                    Date
                                </Typography>
                                <Typography>Time</Typography>
                            </div>
                            <div
                                className="select-a-time-body"
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: !isMobileView && 30,
                                    flexDirection: isMobileView ? 'column' : 'unset',
                                }}>
                                <div>
                                    <Typography className="heading_label d-lg-none">
                                        Choose date <span className="required">*</span>
                                    </Typography>
                                    <SingleCalenderComp
                                        selectedDate={onSelectDate}
                                        displayDate={value?.date}
                                        openCalender={openCalender}
                                        closeTheCalender={() => setOpenCalender(true)}
                                        alwaysOpen={true}
                                    />
                                </div>
                                {!isMobileView && (
                                    <Divider
                                        variant="middle"
                                        orientation="vertical"
                                        style={{ height: '300px', backgroundColor: '#D6D6D6' }}
                                    />
                                )}
                                <div>
                                    <FormControl className="time_form_holder">
                                        <Typography className="heading_label d-lg-none">
                                            Choose time <span className="required">*</span>
                                        </Typography>
                                        <RadioGroup
                                            aria-labelledby="demo-radio-buttons-group-label"
                                            name="radio-buttons-group">
                                            <FormControlLabel
                                                style={{ marginBottom: 50 }}
                                                className="booking_box"
                                                control={
                                                    <CheckboxOption
                                                        checked={value.morning}
                                                        onChange={(event) =>
                                                            setValue(
                                                                event?.target?.checked,
                                                                'morning',
                                                            )
                                                        }
                                                        option={{
                                                            label: `Morning: 8 AM - 12 PM`,
                                                            value: value.morning,
                                                        }}
                                                        customStyle={{
                                                            marginLeft: 18,
                                                        }}
                                                    />
                                                }
                                            />
                                            <FormControlLabel
                                                style={{ marginBottom: 50 }}
                                                className="booking_box"
                                                control={
                                                    <CheckboxOption
                                                        checked={value.afternoon}
                                                        onChange={(event) =>
                                                            setValue(
                                                                event?.target?.checked,
                                                                'afternoon',
                                                            )
                                                        }
                                                        option={{
                                                            label: `Afternoon: 12 PM - 5 PM`,
                                                            value: value.afternoon,
                                                        }}
                                                        customStyle={{
                                                            marginLeft: 18,
                                                        }}
                                                    />
                                                }
                                            />
                                            <FormControlLabel
                                                style={{ marginBottom: 50 }}
                                                className="booking_box"
                                                control={
                                                    <CheckboxOption
                                                        checked={value.evening}
                                                        onChange={(event) =>
                                                            setValue(
                                                                event?.target?.checked,
                                                                'evening',
                                                            )
                                                        }
                                                        option={{
                                                            label: `Evening: 5 PM - 6 PM`,
                                                            value: value.evening,
                                                        }}
                                                        customStyle={{
                                                            marginLeft: 18,
                                                        }}
                                                    />
                                                }
                                            />
                                        </RadioGroup>
                                    </FormControl>
                                </div>
                            </div>
                        </div>
                    )}
                    {step == 3 && (
                        <>
                            <Typography className="upcoming-text">
                                Make a Custom Date Selection{' '}
                            </Typography>
                            <Divider style={{ backgroundColor: '#D6D6D6' }} />
                            {!availabilityLoading && (
                                <div style={{ marginTop: '20px', marginLeft: '7px' }}>
                                    <Grid
                                        container
                                        className="grey_btn_like_holdernew select-a-time-body selectTheDate"
                                        onClick={openTheCalender}
                                        style={{ position: 'relative', minWidth: '150px' }}>
                                        <img
                                            src={calenderTick}
                                            alt=""
                                            style={{ paddingLeft: '5px' }}
                                        />
                                        <Typography className="dateText">
                                            {moment(value?.date).format('MM/DD/YYYY')}
                                        </Typography>
                                        <Box
                                            className="task-user-popper-containerTwo"
                                            style={{
                                                position: 'absolute',
                                                zIndex: 10,
                                                top: '33px',
                                                left: '-2px',
                                            }}>
                                            <SingleCalenderComp
                                                selectedDate={onSelectDate}
                                                displayDate={value?.date}
                                                openCalender={openCalenderSmall}
                                                closeTheCalender={closeTheCalender}
                                                minDate={moment().add(1, 'days')}
                                            />
                                        </Box>
                                    </Grid>
                                </div>
                            )}
                            <div
                                className="provider_filter"
                                style={{ marginTop: '10px', marginLeft: '7px' }}>
                                {['morning', 'afternoon', 'evening'].map((filterItem) => {
                                    return (
                                        <Chip
                                            style={{
                                                background: selectedTimes.includes(filterItem)
                                                    ? '#4765B8'
                                                    : '#A4B1D7',
                                            }}
                                            key={filterItem}
                                            label={capitalText(filterItem)}
                                            disabled={availabilityLoading}
                                            onDelete={() =>
                                                handleFilterControl(filterItem?.toLowerCase())
                                            }
                                            deleteIcon={
                                                selectedTimes.includes(filterItem) ? (
                                                    <ClearIcon
                                                        style={{
                                                            width: 12,
                                                            height: 12,
                                                            color: '#fff',
                                                        }}
                                                    />
                                                ) : (
                                                    <AddIcon
                                                        style={{
                                                            width: 12,
                                                            height: 12,
                                                            color: '#fff',
                                                        }}
                                                    />
                                                )
                                            }
                                        />
                                    )
                                })}
                            </div>
                            {availabilityLoading && (
                                <div className="loadingAvailabilitynew">
                                    <CircularProgress />
                                </div>
                            )}
                            {!availabilityLoading && (
                                <div className="right-container">
                                    <div className="date-conatiner">
                                        {/* Show the main date */}
                                        {newTimeSlot?.slots?.length > 0 && (
                                            <Typography className="dayText">
                                                {moment(value?.date).format('dddd, MMMM D')}
                                            </Typography>
                                        )}
                                        {newTimeSlot?.length == 0 && (
                                            <Typography className="dayText">
                                                Sorry! No slots was found that matched your
                                                selections.
                                            </Typography>
                                        )}
                                        <div
                                            style={{
                                                display: 'flex',
                                                flexWrap: 'wrap',
                                                gap: '5px',
                                                alignItem: 'center',
                                            }}>
                                            {/* Loop through time slots if present */}
                                            {newTimeSlot?.slots?.length > 0 &&
                                                newTimeSlot?.slots?.map((slot, index2) => (
                                                    <div
                                                        className="timeContainer"
                                                        onClick={() => {
                                                            handleChangeOnclick(slot)
                                                            setProviderVisitType(
                                                                newTimeSlot?.visitType,
                                                            )
                                                        }}
                                                        style={{
                                                            background:
                                                                selctedValue?.start_time ==
                                                                    slot?.start_time && '#4765B8',
                                                            color:
                                                                selctedValue?.start_time ==
                                                                    slot?.start_time && '#fff',
                                                        }}>
                                                        {patientTimeZone(
                                                            slot?.start_time,
                                                            timeZoneOfPatient,
                                                        ).format('h:mm A')}
                                                    </div>
                                                ))}
                                        </div>
                                    </div>
                                    {newTimeSlot?.slots?.length == 0 && (
                                        <Typography>No record found</Typography>
                                    )}
                                </div>
                            )}
                        </>
                    )}
                </div>
                <div className="button-container">
                    {step == 1 && (
                        <div style={{ alignItems: 'center' }}>
                            <span
                                className="next-button"
                                onClick={() => {
                                    setStep(2)
                                    handleChangeOnremove()
                                    scrollTop()
                                }}>
                                Make custom date selection
                            </span>
                            <Button
                                variant="contained"
                                disabled={!selctedValue?.start_time}
                                onClick={() => {
                                    showDemoGraphy()
                                    scrollTop()
                                    transLate()
                                }}
                                className="providerDetailsButton">
                                Continue
                            </Button>
                        </div>
                    )}
                    {step == 2 && (
                        <div style={{ alignItems: 'center' }}>
                            <span
                                className="next-button"
                                onClick={() => {
                                    setStep(1)
                                    handleChangeOnremove()
                                    scrollTop()
                                }}>
                                See next available
                            </span>
                            <Button
                                variant="contained"
                                disabled={
                                    (!value.morning && !value.afternoon && !value.evening) ||
                                    !value.date
                                }
                                onClick={() => {
                                    searchForPerticulatProvider()
                                    scrollTop()
                                }}
                                className="providerDetailsButton">
                                Search
                            </Button>
                        </div>
                    )}
                    {step == 3 && (
                        <div style={{ alignItems: 'center' }}>
                            <span
                                className="next-button"
                                onClick={() => {
                                    setStep(2)
                                    scrollTop()
                                }}>
                                Make custom date selection
                            </span>
                            <Button
                                variant="contained"
                                disabled={!selctedValue?.start_time}
                                onClick={() => {
                                    showDemoGraphy()
                                    scrollTop()
                                    transLate()
                                }}
                                className="providerDetailsButton">
                                Continue
                            </Button>
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}

export default ProviderDetails
